import { PrivateAssetResult } from '@ff-os/shared-utils/types/private-assets/PrivateAssetResult';
import { Size } from '@ff-os/shared-utils/types/Size';
import { PrivateUploadHandler } from '@ff-scene-plugins/gift-shared/PrivateUploadHandler';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { getPhotoStatus } from './getPhotoStatus';
import { handleError } from './handleError';
import { handlePending } from './handlePending';
import { handleSuccess } from './handleSuccess';
import { PhotoUploadData } from './PhotoUploadData';
import { saveExternalUpload } from './saveExternalUpload';

export const photoHandler: PrivateUploadHandler<PhotoVariableInput,
    PhotoUploadData,
    PrivateAssetResult<Size>> = {
    pending: handlePending,
    error: handleError,
    ready: handleSuccess,
    externalUpload: saveExternalUpload,
    status: getPhotoStatus
};